import { AchMasterRecipientService } from './achMasterRecipientService.js';

angular
    .module('channel.services.ach', [])
    .factory('achMasterRecipientService', AchMasterRecipientService);
